<template>
    <div class="menuBox">
        <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="to(item.path, item.id)"
        >
            <img :src="item.icon" alt="" />
            <span>{{ item.name }}</span>
        </div>
    </div>
</template>
<script>
import img1 from "@/images/login/menu1.png";
import img2 from "@/images/login/menu2.png";
import img3 from "@/images/login/menu3.png";
import img4 from "@/images/login/menu4.png";
import img5 from "@/images/login/menu5.png";
import img6 from "@/images/login/menu6.png";
import img7 from "@/images/login/menu7.png";
import img8 from "@/images/login/menu8.png";
import { getToken } from "@/utils/auth";
import { system2, signUpTicketId } from "@/api/all";

export default {
    data() {
        return {
            list: [
                {
                    id: 1,
                    path: "/index?wu=1",
                    name: "首页",
                    icon: img1,
                },
                {
                    id: 2,
                    path: "/guideList?wu=1",
                    name: "报考指南",
                    icon: img3,
                },
                {
                    id: 3,
                    path: "/schedule?wu=1",
                    name: "招聘计划",
                    icon: img4,
                },
                // {
                //     id: 4,
                //     path: "/applyForm?type=1",
                //     name: "在线缴费",
                //     icon: img5,
                // },
                {
                    id: 5,
                    path: "/apply?type=3",
                    name: "我的报名表",
                    icon: img5,
                },
                {
                    id: 6,
                    path: "/admissionTicket",
                    name: "打印笔试准考证",
                    icon: img6,
                },
                {
                    id: 7,
                    path: "/interviewTicket",
                    name: "打印面试准考证",
                    icon: img7,
                },
                {
                    id: 8,
                    path: "/achievement?type=2",
                    name: "查看笔试成绩",
                    icon: img8,
                },
                {
                  id: 9,
                  path: "/achievementM?type=2",
                  name: "查看面试成绩",
                  icon: img8,
                },
            ],
            fullPath: "",
            system: {},
        };
    },
    watch: {
        $route() {
            this.fullPath = this.$route.fullPath;
        },
    },
    mounted() {
        this.getSystem();
    },
    methods: {
        getSystem() {
            system2().then((res) => {
                this.system = res.data.system;
            });
        },

        to(url, id) {
            let back_s = localStorage.getItem("back_s");

            if (getToken() || url == "/index?wu=1" || url == "/schedule?wu=1") {
                if (this.fullPath != url) {
                    if (this.system.is_mer_pay_fees_status == 0 && id == 4) {
                        this.$message.error(this.system.is_mer_pay_fees_str);
                        return;
                    }
                    if (this.system.is_select_sign_status == 0 && id == 5) {
                        this.$message.error(this.system.is_select_sign_str);
                        return;
                    }
                    if (
                        this.system.is_print_admission_ticket_status == 0 &&
                        id == 6
                    ) {
                        this.$message.error(
                            this.system.is_print_admission_ticket_str
                        );
                        return;
                    }
                    if (
                        this.system.is_mer_interview_ticket_status == 0 &&
                        id == 7
                    ) {
                        this.$message.error(
                            this.system.is_mer_interview_ticket_str
                        );
                        return;
                    }
                    if (this.system.is_view_score_status == 0 && id == 8) {
                        this.$message.error(this.system.is_view_score_str);
                        return;
                    }
                    if (this.system.is_view_m_score_status == 0 && id == 9) {
                        this.$message.error(this.system.is_view_m_score_str);
                        return;
                    }
                    if (id < 5) {
                        this.$router.push({
                            path:"/"+back_s+url,
                        });
                    } else {
                        signUpTicketId().then((res) => {
                            if (res.data) {
                              console.log("/"+back_s+url)
                                this.$router.push({
                                    path:"/"+back_s+url,
                                });
                            } else {
                                this.$message.error("您还没有报名，请先报名");
                                return;
                            }
                        });
                    }
                }
            } else {
                this.$message.error("请先登录");
            }
        },
    },
};
</script>

<style lang="less" scoped>
.menuBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 30px;
    .item {
        width: 278px;
        background: #fff;
        margin-right: 29px;
        box-sizing: border-box;
        padding: 30px;
        margin-bottom: 30px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:nth-child(4n) {
            margin-right: 0;
        }
        img {
            width: 52px;
            height: 52px;
            margin-right: 20px;
        }
    }
}
</style>
